
export function getFormKey(entity: string, jahr: number, idx: number, extraIdx: number, energieKey?: string, standortTid?: number) {
    const formKey = [
        entity,
        jahr,
        standortTid || 0,
        energieKey ? energieKey : (typeof idx === 'number' && idx >= 0 ? idx : 'X'),
        typeof extraIdx === 'number' && extraIdx >= 0 ? extraIdx : 'X'
    ].join('_');
    return formKey;
}

export function getKomplexRowClassname(formKey: string, suffix?: string) {
    let classname;
    if (formKey && typeof formKey === 'string') {
        const strArr = formKey.split('_');
        const extraIdx = strArr.pop();
        const idx = strArr.pop();
        const standortTid = strArr.pop();
        const jahr = strArr.pop();
        const entity = strArr.join('_');
        if (entity && idx && extraIdx) {
            const newStrArr = [entity, idx, extraIdx];
            if (suffix && typeof suffix === 'string') {
                newStrArr.push(suffix);
            }
            classname = newStrArr.join('_');
        }
        // console.log(entity, jahr, standortTid, idx, extraIdx, classname);
    }
    return classname;
}

export function getCombiFieldKey(combiFields: Array<string>): string {
    if (Array.isArray(combiFields)) {
        return `combi_${combiFields[0] || 'undefined'}_${combiFields[1] || 'undefined'}`;
    }
    return undefined;
}